import { has, isArray } from 'lodash-es'

const POSITION_ABOVE = '__above__'
const POSITION_BELOW = '__below__'

export default {
  clear,

  above,
  below,

  isAbove,
  isBelow,

  _hasPosition
}

function _hasPosition(post) {
  return has(post, 'position')
}

function clear(post) {
  if (isArray(post)) {
    post.forEach(clear)
  } else {
    delete post.position
  }

  return post
}

function above(post) {
  if (isArray(post)) {
    post.forEach(above)
  } else {
    post.position = POSITION_ABOVE
  }
  return post
}

function below(post) {
  if (isArray(post)) {
    post.forEach(below)
  } else {
    post.position = POSITION_BELOW
  }
  return post
}

function isAbove(post) {
  return post.position === POSITION_ABOVE
}

function isBelow(post) {
  return post.position === POSITION_BELOW
}
